import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './components/LandingPage/Layout';
import Landing from './components/LandingPage/Landing/Landing';
import SponsoredPage from './components/SponsoredPage/SponsoredPage';
import TermsPage from './components/TermsPage/TermsPage';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Landing />
            </Layout>
          }
        />
        <Route path="/sponsored" element={<SponsoredPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
    </div>
  );
}

export default App;
